import React from 'react';

import { THEME } from '@constants/index';
import { openModal } from '@element/index'
import { I18n } from '@utils/index';

import styles from './index.module.less';

/** 没有完成 KYC1 */
export const openNotKyc1 = ({ theme = THEME.HIGHLIGHT }: { theme?: Theme }): Promise<'cancel' | 'ok'> => {
  return new Promise((resolve) => {
    openModal({
      title: I18n.t('4QVCmGvk'),
      theme,
      children: (
        (<div className={styles.main}>{I18n.t('jUP0Lau4')}</div>)
      ),
      cancelButtonProps: {
        'data-buried': 'cancel-kyc1'
      },
      okButtonProps: {
        'data-buried': 'set-cancel-kyc1'
      },
      okText: I18n.t('XQkx3Fkq'),
      cancelText: I18n.t('common_cancel'),
      onCancel: (close) => () => {
        close();
        resolve('cancel')
      },
      onOk: (close) => () => {
        close()
        resolve('ok')
      }
    })
  });
}
